<template>
    <div class="addBox relative">
      <div class="title">
        <div class="title_left">
          <span class="movePoin" @click="$router.go(-1)">来源管理</span>
          /
          <span class="type">{{$route.query.type=='add'?'新增':'编辑'}}</span>
        </div>
      </div>
      <el-form :model="bizEntityForm" :rules="rules" ref="bizEntityForm" label-width="150px">
        <ToggleForm title="基本信息">
          <div class="content">
            <div class="row mt20">
              <el-form-item label="来源名称：" prop="name">
                <el-input placeholder="请输入来源名称" class="w300" maxlength="30" v-model="bizEntityForm.name"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="所在区域：" prop="areaCode">
                <!-- <el-select v-model="" placeholder="请选择所在区域" class="w300">
                  <el-option v-for="item in entityLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
                <el-cascader v-model="bizEntityForm.areaCode" id="areaCode" :options="qyOptions" class="w300"
                             @change="handleChange" :props="props"></el-cascader>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="经营地址：" prop="addr">
                <el-input placeholder="请输入经营地址" class="w300" maxlength="30" v-model="bizEntityForm.addr"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="联系方式：" prop="tel">
                <el-input placeholder="请输入联系方式" class="w300" maxlength="30" v-model="bizEntityForm.tel"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="法人/负责人：">
                <el-input placeholder="请输入法人/负责人" class="w300" maxlength="30" v-model="bizEntityForm.legalPerson"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="身份证号：">
                <el-input placeholder="请输入身份证号" class="w300" maxlength="30" v-model="bizEntityForm.idCard"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="上传证照：">
                <div class="pzUploadBox">
                  <ybUploadFill class="ybUpload" @changeFun="getFilesO" :baseUrl="baseUrl" :filesArr="tranVoucherList"></ybUploadFill>
                  <ybUploadFill class="ybUpload" @changeFun="getFilesT" :baseUrl="baseUrl" :filesArr="animalVoucherList"></ybUploadFill>
                </div>
                <p class="imgTipP">
                  <span>营业执照</span>
                  <span>食品经营许可证</span>
                </p>
                <p class="tipP">图片大小不超过5M；</p>
                <p class="tipP">上传格式：jpg、png、gif；每一类最多上传1张图片。</p>
              </el-form-item>
            </div>
          </div>
        </ToggleForm>
      </el-form>
      <div class="foot-btn">
        <div>
          <el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
          <el-button type="primary w70" :disabled="btn"  @click="submit">提交</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import ybUploadFill from "components/ybUploadFill";
import * as api from "api/report";
export default {
  name: "personAdd",
  components: { 
      ToggleForm,
      ybUploadFill,
  },
  data() {
    return {
      id: '',
      type: '',
      bizEntityForm: {
        addr: '', //经营地址
        areaCode: '',  //区域code
        areaName: '',  //区域名称
        creditCode: '',  //统一社会信用代码
        creditLicenseFileId: '', //营业执照
        id: '', //来源id编辑必填, 
        idCard: '',  //身份证
        legalPerson: '', //法人
        licenceFileId: '', //许可证
        name: '',  //来源名称
        tel: '' //联系方式
      },
      entityLists: [],
      animalVoucherList: [],
      tranVoucherList: [],
      baseUrl: this.$store.state.common.baseUrl,
      btn: false,
      qyOptions: [],
      props: {
        value: 'areaId',
        label: 'areaName',
        children: 'children'
      },
      rules: {
        name: [{
          required: true,
          message: '请输入来源名称',
          trigger: 'blur'
        }],
        areaCode: [{
          required: true,
          message: '请选择所在区域',
          trigger: 'blur'
        }],
        addr: [{
          required: true,
          message: '请输入经营地址',
          trigger: 'blur'
        }],
        tel: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'blur'
        }]
      },
    };
  },
  methods: {
    handleChange(val){
      this.bizEntityForm.areaCode = val[val.length-1].slice(0,6);
      setTimeout(() => {
        this.bizEntityForm.areaName = document.getElementById('areaCode').children[0].children[0].value;
      }, 100);
    },
    getFilesO(files, state) {
      if(files.length>0){
        this.bizEntityForm.creditLicenseFileId = files[0].fileId;
      } else {
        this.bizEntityForm.creditLicenseFileId = '';
      }
    },
    getFilesT(files, state) {
      if (files.length > 0) {
        this.bizEntityForm.licenceFileId = files[0].fileId;
      } else {
        this.bizEntityForm.licenceFileId = '';
      }
    },
    submit() {//提交
      if (!this.bizEntityForm.name || !this.bizEntityForm.addr ||
          !this.bizEntityForm.areaCode || !this.bizEntityForm.tel) {
        this.$message.error('请完善基本信息');
        return
      }
      this.btn = true;
      let addFun = this.type == 'add' ? api.entityAdd(this.bizEntityForm) : api.entityUpdate(this.bizEntityForm);
      addFun.then(r=>{
        this.btn = false;
        if(r.code == 200){
          this.$message.success('提交成功');
          this.$router.go(-1);
        }
      })
    },
    getTobTsysAreaTree(id){
      api.getTobTsysAreaTree({ parentId: id}).then(r=>{
        if(r.code == 200){
          this.qyOptions = r.data.children;
        }
      })
    },
    initEditData() {
      api.entityGet({id: this.$route.query.id}).then(r=>{
        if(r.code == 200){
          this.bizEntityForm = r.data;
          if(r.data.creditLicenseFile.length>0){
            this.tranVoucherList = r.data.creditLicenseFile;
            this.tranVoucherList[0].url = this.baseUrl + '/' + this.tranVoucherList[0].fileId;
            this.bizEntityForm.creditLicenseFileId = this.tranVoucherList[0].id;
          } else {
            this.bizEntityForm.creditLicenseFileId = '';
          } 
          if(r.data.licenceFile.length>0){
            this.animalVoucherList = r.data.licenceFile;
            this.animalVoucherList[0].url = this.baseUrl + '/' + this.animalVoucherList[0].fileId;
            this.bizEntityForm.licenceFileId = this.animalVoucherList[0].id;
          } else {
            this.bizEntityForm.licenceFileId = '';
          }
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id ? this.$route.query.id : "";
    this.getTobTsysAreaTree('0')
  },
  created() {
    this.type = this.$route.query.type
    if(this.type === 'edit') { // 编辑页
      this.initEditData()
    }
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
  .content{
    padding: 0 30px;
    .tabLab{
      width: 180px;
      display: block;
      text-align: center;
    }
  }
}
.margin-10{
  margin-left: -10px;
}
.w80{
  width: 80px;
}
.w140{
  width: 140px;
}
.pinzheng_span{
  font-size: 14px;
  color: #70CE97;
  cursor: pointer;
}
.w70{
  width: 70px;
}
.pzUploadBox{
  overflow: hidden;
  .ybUpload{
    width: 100px;
    height: 100px;
    overflow: hidden;
    float: left;
    margin-right: 30px;
  }
  .ybUpload:last-child{
    margin-right: 0;
  }
}
.imgTipP{
  color: #666;
  font-style: 14px;
  padding: 10px 0;
  line-height: 20px;
  span{
    display: inline-block;
    width: 100px;
    margin-right: 30px;
    text-align: center;
  }
  span:last-child{
    margin-right: 0;
  }
}
.tipP{
  color: #999;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
</style>
<style>
  .pzUploadBox .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 120px;
  }
  .pzUploadBox .el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
</style>